import React, { useState } from 'react';
import { DoorOpen, FileText, ScrollText } from 'lucide-react';

const ICONA = { apertura: DoorOpen, documento: FileText, registro: ScrollText };
const quando = (iso) => new Date(iso).toLocaleString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });

const Voce = ({ a }) => {
  const Icona = ICONA[a.azione] || FileText;
  const apertura = a.azione === 'apertura';
  return (
    <li className="pl-6 relative" data-testid={`owner-access-log-item-${a.id}`}>
      <span className={`absolute -left-3 top-0 w-6 h-6 rounded-full flex items-center justify-center ring-4 ring-white ${apertura ? 'bg-amber-500 text-white' : 'bg-slate-100 text-slate-700'}`}>
        <Icona className="h-3 w-3" />
      </span>
      <p className={`text-sm text-slate-900 ${apertura ? 'font-bold' : 'font-medium'}`}>{apertura ? `Cartella aperta – ${a.profilo_nome}` : a.titolo}</p>
      <p className="text-xs text-slate-500">{quando(a.quando)} · {a.dispositivo}</p>
    </li>
  );
};

export const RegistroAccessi = ({ accessi, profilo }) => {
  const [tutti, setTutti] = useState(false);
  const voci = tutti ? accessi : accessi.filter((a) => a.profilo === profilo);
  return (
    <section className="bg-white rounded-2xl border border-slate-200 p-4 lg:p-5 space-y-4" data-testid="owner-access-log">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h4 className="font-bold text-slate-900">Cosa ha aperto l'ispettore</h4>
          <p className="text-sm text-slate-600">Ti avvisiamo sul telefono appena apre la cartella; qui vedi ogni documento che consulta.</p>
        </div>
        <button type="button" onClick={() => setTutti(!tutti)} data-testid="owner-access-log-filter"
          className="shrink-0 text-xs font-semibold text-slate-700 border border-slate-200 rounded-full px-3 h-8 hover:border-slate-900 transition-colors">
          {tutti ? 'Solo questo ispettore' : 'Tutti gli ispettori'}
        </button>
      </div>
      {!voci.length && <p className="text-sm text-slate-500 bg-slate-50 rounded-xl p-4" data-testid="owner-access-log-empty">Nessuna apertura finora.</p>}
      {voci.length > 0 && <ol className="border-l border-slate-200 ml-3 space-y-4">{voci.map((a) => <Voce key={a.id} a={a} />)}</ol>}
    </section>
  );
};
